import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ysb",
  "use": "icon-ysb-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ysb\"><defs><style type=\"text/css\"></style></defs><path d=\"M97.9 376h828.4v269.2H97.9z\" fill=\"#F95F5D\" p-id=\"749\" /><path d=\"M926.3 376V161.5c0-26.6-23.8-50.3-52.1-50.3H149.9c-28.3 0-52.1 23.7-52.1 50.3V376h828.5z m0 0\" fill=\"#55C7F7\" p-id=\"750\" /><path d=\"M97.9 645.2v214.5c0 26.6 23.6 50.3 51.7 50.3h725c28.1 0 51.7-23.7 51.7-50.3V645.2H97.9z m0 0\" fill=\"#7ECF3B\" p-id=\"751\" /><path d=\"M421.8 111.2h184.9V910H421.8z\" fill=\"#FDAF42\" p-id=\"752\" /><path d=\"M606.7 457.4v112.4H413V457.4h193.7m31.1-45.9H381.9c-4.4 0-11.8 4.4-11.8 11.8v179c0 4.4 4.4 11.8 11.8 11.8h255.9c4.4 0 11.8-4.4 11.8-11.8v-179c-2.9-8.8-7.4-11.8-11.8-11.8z m0 0\" fill=\"#FFFFFF\" p-id=\"753\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ysb.svg
// module id = 1z9d
// module chunks = 77